import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import './ComenziMele.css';

const ComenziMele = () => {
  const [comenzi, setComenzi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedComanda, setSelectedComanda] = useState(null);

  const statusLabels = {
    'plasata': { label: 'Plasată', color: '#2196F3', icon: '📝' },
    'confirmata': { label: 'Confirmată', color: '#FF9800', icon: '✓' },
    'in preparare': { label: 'În Preparare', color: '#9C27B0', icon: '👨‍🍳' },
    'livrata': { label: 'Livrată', color: '#4CAF50', icon: '✅' },
    'anulata': { label: 'Anulată', color: '#F44336', icon: '❌' }
  };

  useEffect(() => {
    loadComenzi();
  }, []);

  const loadComenzi = async () => {
    try {
      const response = await axios.get('/api/comenzi');
      setComenzi(response.data);
    } catch (error) {
      console.error('Eroare la încărcare comenzi:', error);
    } finally {
      setLoading(false);
    }
  };

  const viewDetails = async (comanda) => {
    try {
      const response = await axios.get(`/api/comenzi/${comanda._id}`);
      setSelectedComanda(response.data);
    } catch (error) {
      console.error('Eroare la încărcare detalii comandă:', error);
    }
  };

  const handleAnuleaza = async (comandaId) => {
    if (!window.confirm('Sigur dorești să anulezi această comandă?')) {
      return;
    }

    try {
      await axios.delete(`/api/comenzi/${comandaId}`);
      loadComenzi();
      setSelectedComanda(null);
    } catch (error) {
      console.error('Eroare la anulare comandă:', error);
      alert(error.response?.data?.message || 'Eroare la anulare comandă');
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('ro-RO', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatDateTime = (date) => {
    return new Date(date).toLocaleString('ro-RO', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) return <div>Se încarcă...</div>;

  return (
    <div>
      <div className="page-header">
        <h1>Comenzile Mele</h1>
        <p>Vizualizează și gestionează comenzile tale</p>
      </div>

      {comenzi.length === 0 ? (
        <div className="card">
          <div className="no-comenzi">
            <div className="no-comenzi-icon">📭</div>
            <h3>Nu ai comenzi încă</h3>
            <p>Comenzile tale vor apărea aici după ce le plasezi.</p>
          </div>
        </div>
      ) : (
        <div className="comenzi-grid">
          {comenzi.map(comanda => {
            const status = statusLabels[comanda.status];
            return (
              <div key={comanda._id} className="comanda-card">
                <div className="comanda-header">
                  <div>
                    <h3>{formatDate(comanda.data)}</h3>
                    <p className="comanda-date">Plasată: {formatDateTime(comanda.createdAt)}</p>
                  </div>
                  <span 
                    className="status-badge"
                    style={{ backgroundColor: status.color }}
                  >
                    {status.icon} {status.label}
                  </span>
                </div>

                <div className="comanda-summary">
                  <div className="summary-item">
                    <span className="summary-label">Articole:</span>
                    <span className="summary-value">{comanda.items.length}</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label">Total Porții:</span>
                    <span className="summary-value">{comanda.totalPortii}</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label">Total:</span>
                    <span className="summary-value total-price">{comanda.pretTotal.toFixed(2)} lei</span>
                  </div>
                </div>

                <div className="comanda-actions">
                  <button 
                    className="btn btn-secondary btn-sm"
                    onClick={() => viewDetails(comanda)}
                  >
                    Vezi Detalii
                  </button>
                  {comanda.status === 'plasata' && (
                    <button 
                      className="btn btn-danger btn-sm"
                      onClick={() => handleAnuleaza(comanda._id)}
                    >
                      Anulează
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {selectedComanda && (
        <div className="modal-overlay" onClick={() => setSelectedComanda(null)}>
          <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Detalii Comandă</h2>
              <button className="modal-close" onClick={() => setSelectedComanda(null)}>&times;</button>
            </div>
            
            <div className="modal-body">
              <div className="detail-section">
                <h3>Informații Comandă</h3>
                <div className="detail-grid">
                  <div className="detail-item">
                    <strong>Data Comenzii:</strong>
                    <span>{formatDate(selectedComanda.data)}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Plasată La:</strong>
                    <span>{formatDateTime(selectedComanda.createdAt)}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Status:</strong>
                    <span 
                      className="status-badge"
                      style={{ backgroundColor: statusLabels[selectedComanda.status].color }}
                    >
                      {statusLabels[selectedComanda.status].icon} {statusLabels[selectedComanda.status].label}
                    </span>
                  </div>
                </div>
              </div>

              <div className="detail-section">
                <h3>Articole Comandate</h3>
                <table>
                  <thead>
                    <tr>
                      <th>Articol</th>
                      <th>Categorie</th>
                      <th>Preț/porție</th>
                      <th>Porții</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedComanda.items.map((item, index) => (
                      <tr key={index}>
                        <td>{item.meniu?.nume || item.numeArticol}</td>
                        <td>{item.categorie}</td>
                        <td>{item.pret.toFixed(2)} lei</td>
                        <td>{item.numarPortii}</td>
                        <td>{(item.pret * item.numarPortii).toFixed(2)} lei</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="detail-section">
                <div className="total-summary">
                  <div className="total-row">
                    <span>Total Porții:</span>
                    <strong>{selectedComanda.totalPortii}</strong>
                  </div>
                  <div className="total-row final-total">
                    <span>Total Comandă:</span>
                    <strong>{selectedComanda.pretTotal.toFixed(2)} lei</strong>
                  </div>
                </div>
              </div>

              {selectedComanda.observatii && (
                <div className="detail-section">
                  <h3>Observații</h3>
                  <div className="observatii-box">
                    {selectedComanda.observatii}
                  </div>
                </div>
              )}

              {selectedComanda.status === 'plasata' && (
                <div className="modal-actions">
                  <button 
                    className="btn btn-danger"
                    onClick={() => handleAnuleaza(selectedComanda._id)}
                  >
                    Anulează Comanda
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ComenziMele;
